import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './AuthContext';

export const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === 'loading') {
    return <div className="p-6 text-sm text-gray-500">読み込み中...</div>;
  }
  if (state.status !== 'signed-in') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
};
